import { Routes } from '@angular/router';
import { HomeComponent } from './layout/home/home';
import { LayoutBaseComponent } from './layout/layoutBase/layoutBase';
import { CatalogoBaseComponent } from './features/catalogo/catalogo-base/catalogo-base-component';
import { ProductDetailPageComponent } from './features/product-addon/product-detail-page.component';
import { CheckoutStepperComponent } from './features/checkOut/checkout-stepper.component';
import { LoginPageComponent } from './features/auth/login-page.component';
import { AdminLayoutComponent } from './features/admin/admin-layout.component';
import { AdminProductosComponent } from './features/admin/admin-productos.component';
import { AdminProductoFormComponent } from './features/admin/admin-producto-form.component';
import { AdminCategoriasComponent } from './features/admin/admin-categorias.component';
import { AdminEmpresaComponent } from './features/admin/admin-empresa.component';
import { AdminTallerComponent } from './features/admin/admin-taller.component';
import { AdminPagosComponent } from './features/admin/admin-pagos.component';
import { AdminCapacidadComponent } from './features/admin/admin-capacidad.component';
import { AdminPedidosComponent } from './features/admin/admin-pedidos.component';
import { AdminUsuariosComponent } from './features/admin/admin-usuarios.component';
import { SeguimientoComponent } from './features/seguimiento/seguimiento.component';
import { MisPedidosComponent } from './features/mis-pedidos/mis-pedidos.component';
import { adminGuard, authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: 'auth/login',
        component: LoginPageComponent
    },
    {
        path: 'auth/register',
        component: LoginPageComponent
    },
    {
        path: 'admin',
        component: AdminLayoutComponent,
        canActivate: [adminGuard],
        children: [
            { path: '', redirectTo: 'productos', pathMatch: 'full' },
            { path: 'productos', component: AdminProductosComponent },
            { path: 'productos/nuevo', component: AdminProductoFormComponent },
            { path: 'productos/:uuid', component: AdminProductoFormComponent },
            { path: 'categorias', component: AdminCategoriasComponent },
            { path: 'empresa', component: AdminEmpresaComponent },
            { path: 'taller', component: AdminTallerComponent },
            { path: 'pagos', component: AdminPagosComponent },
            { path: 'capacidad', component: AdminCapacidadComponent },
            { path: 'pedidos', component: AdminPedidosComponent },
            { path: 'usuarios', component: AdminUsuariosComponent }
        ]
    },
    {
        path: '',
        component: LayoutBaseComponent,
        children: [
            { path: '', component: HomeComponent },
            { path: 'catalogo', component: CatalogoBaseComponent },
            { path: 'catalogo/:slug', component: CatalogoBaseComponent },
            { path: 'producto/:slug', component: ProductDetailPageComponent },
            { path: 'flores', redirectTo: 'catalogo', pathMatch: 'full' },
            { path: 'rosa-roja', redirectTo: 'catalogo', pathMatch: 'full' },
            { path: 'finalizar-compra', component: CheckoutStepperComponent },
            { path: 'seguimiento', component: SeguimientoComponent },
            {
                path: 'mis-pedidos',
                component: MisPedidosComponent,
                canActivate: [authGuard]
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
